import React from 'react';
import SupplierMetersIndexPage from '../supplier_meters_index_page/SupplierMetersIndexPage';

export default function SupplierMetersActiveIndexPage() {
	return (
		<SupplierMetersIndexPage
			preAppliedFilters={{ isArchived: 'false' }}
			targetCollectionName="metersIndex"
		/>
	);
}
